export default {
  sections: {
    order_summary: 'Order summary',
  },
  labels: {
    add_items: 'Add items to get started',
  },
  buttons: {
    return: 'Return',
  },
  tip: 'Tip',
};
